import { useState, useEffect } from "react";

const HeaderToggleMenuButton = ({ isNavOpen, setIsNavOpen }) => {
  const WIDTH_LG_BREAKPOINT = 992; // 992px = Bootstrap lg breakpoint

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < WIDTH_LG_BREAKPOINT,
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < WIDTH_LG_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!isNavOpen) return;

    const handleClick = () => {
      setIsNavOpen(false);
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [isNavOpen, setIsNavOpen]);

  const buttonBaseStyle = {
    all: "unset",
    position: "fixed",
    top: "12px",
    right: "12px",
    zIndex: 9999,
    width: "44px",
    height: "44px",
    padding: "10px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  };

  const iconBoxStyle = {
    position: "relative",
    width: "24px",
    height: "18px",
  };

  const barBaseStyle = {
    position: "absolute",
    left: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#fff",
    borderRadius: "2px",
    pointerEvents: "none",
  };

  if (!isMobile) return null;

  return (
    <button
      type="button"
      onClick={() => setIsNavOpen((prev) => !prev)}
      style={buttonBaseStyle}
    >
      <div style={iconBoxStyle}>
        {/* Top bar */}
        <span
          style={{
            ...barBaseStyle,
            top: isNavOpen ? "8px" : "0px",
            transform: isNavOpen ? "rotate(45deg)" : "none",
            transition: "top 0.2s ease, transform 0.2s ease",
          }}
        />

        {/* Middle bar */}
        <span
          style={{
            ...barBaseStyle,
            top: "8px",
            opacity: isNavOpen ? 0 : 1,
            transition: "opacity 0.2s ease",
          }}
        />

        {/* Bottom bar */}
        <span
          style={{
            ...barBaseStyle,
            top: isNavOpen ? "8px" : "16px",
            transform: isNavOpen ? "rotate(-45deg)" : "none",
            transition: "top 0.2s ease, transform 0.2s ease",
          }}
        />
      </div>
    </button>
  );
};

export default HeaderToggleMenuButton;
